<template>
    <v-app-bar color="primary" dark app flat>
        <!-- LOGO -->
        <v-toolbar-items class="mx-4">
            <router-link
                :to="homepageRoute"
                class="mt-1 t-md-3"
            >
                <img alt="logo" src="/svg/logo-white.svg" height="45" contain />
            </router-link>
        </v-toolbar-items>
        <v-spacer />

        <!-- Navigation -->
        <v-tabs
            id="headerTabs"
            class="hidden-md-and-down"
            background-color="primary"
            centered
            dark
            hide-slider
            :style="{'max-width': headerTabsMaxWidth}"
        >
            <v-tab
                v-if="$_user.can_post_offers"
                href="/offers/new"
                class="px-6 mr-5"
            >
                Send Money <br>Internationally
            </v-tab>
            <v-tab
                v-if="$_user.can_post_offers"
                href="/offers/list"
                class="px-6 mr-5"
            >
                Request Money <br>Internationally
            </v-tab>
            <v-tab
                v-if="$_user.can_post_offers && !isProduction()"
                @click="showInvoiceModal = true"
                class="px-6"
            >Invoice Money <br /> Internationally</v-tab>
            <template v-if="!$_user.can_post_offers">
                <v-tab
                    href="/offers/list"
                    class="px-6 mr-5">
                    International <br /> Money Transfer
                </v-tab>
            </template>
            <v-tab
                v-if="$store.state.user.can_accept_offers && !isProduction()"
                :to="{ name: 'healthcare' }"
                class="px-6 mr-5"
            >
                Health
            </v-tab>
            <template v-if="!$store.state.user.can_post_offers && !isUserAuthenticated">
                <v-tab
                    @click="showShoppingModal = true"
                    v-if="!$store.state.user.can_post_offers"
                    class="coming-soon amber--text text--lighten-3 px-6">
                    Coming Soon<br>Shopping
                </v-tab>
                <v-tab
                    @click="showAutoLoanModal = true"
                    v-if="!$store.state.user.can_post_offers"
                    class="coming-soon amber--text text--lighten-3 px-6">
                    Coming Soon<br>AutoLoan
                </v-tab>
                <v-tab
                    @click="showWalletModal = true"
                    v-if="!$_user.can_post_offers"
                    class="coming-soon amber--text text--lighten-3 px-6">
                    Coming Soon<br>Wallet
                </v-tab>
            </template>
            <template v-else>
                <template v-for="(item, key) in navbarItems">
                    <v-tab
                        :key="key"
                        :to="item.route"
                        class="px-6 navbar-item mr-5"
                    >
                        <v-badge
                            color="error"
                            v-if="item.key === 'transfers'"
                            :content="$store.state.activeMatchesCount"
                            :value="$store.state.activeMatchesCount"
                        >
                            {{ item.text }}
                        </v-badge>
                        <v-badge
                            color="error"
                            v-if="item.key === 'requests'"
                            :content="$store.state.activeRequestsCount"
                            :value="$store.state.activeRequestsCount"
                        >
                            {{ item.text }}
                        </v-badge>
                        <span v-if="!item.key">{{ item.text }}</span>
                    </v-tab>
                </template>
                <v-tab
                    v-if="!$store.state.user.can_post_offers"
                    @click="showComingSoon = true"
                    class="coming-soon navbar-item amber--text text--lighten-3 px-6">
                    Coming Soon
                </v-tab>
            </template>
        </v-tabs>

        <v-dialog v-model="showComingSoon" max-width="600px" height="400px" @click:outside="showComingSoon = false">
            <v-card class="overflow-hidden">
                <v-toolbar color="primary" dark flat>
                    <v-toolbar-title>Coming Soon</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon color="white" @click="showComingSoon = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-row class="pa-3" v-if="!$store.state.user.can_post_offers">
                    <v-col cols="6">
                        <v-card
                            color="rgba(255, 0, 0, 0.5)"
                            class="py-8 px-4 darken-1 text--lighten-3 text-center"
                            flat
                            @click="showShoppingModal = true"
                        >
                            <v-icon
                                color="#76CDD4"
                                large
                            >
                                mdi-cart
                            </v-icon>
                            <br>
                            <h4>Shopping</h4>
                            <span class="white--text">Click here to learn more</span>
                        </v-card>
                    </v-col>

                    <v-col cols="6">
                        <v-card
                            class="py-8 px-4 darken-1 text--lighten-3 text-center"
                            flat
                            color="#90A0D3"
                            @click="showAutoLoanModal = true"
                        >
                            <v-icon
                                color="yellow"
                                large
                            >
                                mdi-car-estate
                            </v-icon>
                            <br>
                            <h4>AutoLoan</h4>
                            <span>Click here to learn more</span>
                        </v-card>
                    </v-col>

                    <v-col cols="6">
                        <v-card
                            color="#E0BC9C"
                            class="py-8 px-4 darken-1 text--lighten-3 text-center"
                            flat
                            @click="showWalletModal = true"
                        >
                            <v-icon
                                color="green"
                                large
                            >
                                mdi-wallet
                            </v-icon>
                            <br>
                            <h4>Wallet</h4>
                            <span>Click here to learn more</span>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>

        <health-modal
            v-if="!$store.state.user.can_post_offers"
            :visible="showHealthModal"
            :key="componentKey+'health'"
            @close="showHealthModal = false; componentKey += 1;"
        />
        <invoice-modal
            :key="componentKey+'invoice'"
            v-else
            :show.sync="showInvoiceModal"
        />

        <shopping-modal
            :key="componentKey+'shopping'"
            v-if="!$store.state.user.can_post_offers"
            :visible="showShoppingModal"
            @close="showShoppingModal = false; componentKey += 1;"
        />

        <autoloan-modal
            v-if="!$store.state.user.can_post_offers"
            :visible="showAutoLoanModal"
            :key="componentKey+'autoloan'"
            @close="showAutoLoanModal = false; componentKey += 1;"
        />

        <wallet-model
            v-if="!$store.state.user.can_post_offers"
            :visible="showWalletModal"
            :key="componentKey+'wallet'"
            @close="showWalletModal = false; componentKey += 1;"
        />

        <v-spacer></v-spacer>

        <v-toolbar-items
            v-if="isUserAuthenticated"
            ref="profileInfo"
        >
            <!-- Cart -->
            <v-btn
                v-if="$store.state.autoloans.length && !$store.state.user.can_post_offers && $route.name.includes('autoloan')"
                icon
                right
                class=""
                href="/autoloan/checkout"
            >
                <v-badge
                    overlap
                    color="error lighten-1"
                >
                    <template v-slot:badge>
                        <span> {{ $store.state.autoloans.length }} </span>
                    </template>
                    <v-icon color="#fff">
                        mdi-cart
                    </v-icon>
                </v-badge>
            </v-btn>
            <v-btn
                v-if="$store.state.shoppingList.length && !$store.state.user.can_post_offers && $route.name.includes('shopping')"
                icon
                right
                class=""
                href="/shopping/checkout"
            >
                <v-badge
                    overlap
                    color="error lighten-1"
                >
                    <template v-slot:badge>
                        <span> {{ $store.state.shoppingList.length }} </span>
                    </template>
                    <v-icon color="#fff">
                        mdi-cart
                    </v-icon>
                </v-badge>
            </v-btn>

            <!-- Messages -->
            <v-btn
                icon
                right
                class=""
                href="/user/messages"
            >
                <template
                    v-if="unreadMessagesCount && unreadMessagesCount != 0"
                >
                    <v-badge
                        overlap
                        color="error lighten-1"
                        :content="unreadMessagesCount"
                    >
                        <v-icon>mdi-email-outline</v-icon>
                    </v-badge>
                </template>
                <template v-else>
                    <v-icon>mdi-email-outline</v-icon>
                </template>
            </v-btn>

            <!-- Notifications -->
            <v-menu z-index="9" offset-y :close-on-content-click="notifMenuCloseOnClick" v-model="showNotifications">
                <template v-slot:activator="{ on }">
                    <v-btn
                        icon
                        right
                        v-on="on"
                        class="ma-0"
                        :disabled="enableNotificationButton === false"
                    >
                        <v-badge
                            overlap
                            color="error lighten-1"
                            :value="newNotificationsCount > 0"
                        >
                            <template v-slot:badge>
                                <span v-if="newNotificationsCount < 99">
                                    {{ newNotificationsCount }}
                                </span>
                                <span v-else>99+</span>
                            </template>
                            <v-icon>mdi-bell-outline</v-icon>
                        </v-badge>
                    </v-btn>
                </template>

                <v-list
                    max-width="300"
                    min-width="300"
                    max-height="40vh"
                    class="notificationsList pb-11 mb-3"
                >
                    <v-row no-gutters>
                        <v-col>
                            <template
                                v-for="(notification, index) in notifications"
                            >
                                <v-list-item
                                    :key="notification.id"
                                    :class="{ read: !!notification.read_at }"
                                    class="py-2 mx-3"
                                >
                                    <v-col class="pa-0">
                                        <v-row no-gutters>
                                            <v-col>
                                                <v-list-item-content>
                                                    <div
                                                        class="notification body-2"
                                                        v-html="
                                                            notification.message
                                                        "
                                                    ></div>
                                                </v-list-item-content>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            no-gutters
                                            class="flex-nowrap align-center justify-space-between"
                                        >
                                            <v-col>
                                                <v-list-item-content>
                                                    <span
                                                        class="caption blue-grey--text"
                                                    >
                                                        {{
                                                            notification.created_at
                                                                | moment(
                                                                    'MMM Do'
                                                                )
                                                        }}
                                                        at
                                                        {{
                                                            notification.created_at
                                                                | moment(
                                                                    'hh:mm A'
                                                                )
                                                        }}
                                                    </span>
                                                </v-list-item-content>
                                            </v-col>
                                            <v-col
                                                right
                                                class="flex-grow-0 flex-nowrap"
                                            >
                                                <v-row
                                                    no-gutters
                                                    class="flex-nowrap"
                                                >
                                                    <v-col>
                                                        <v-btn
                                                            icon
                                                            @click="deleteNotification(notification)"
                                                            color="error"
                                                        >
                                                            <v-icon
                                                                class="xx-small"
                                                                small
                                                            >mdi-trash-can-outline</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-list-item>

                                <!--
                                Element within <template> requires a key, but cannnot use the same key as v-list-item. So this is a quick alternative.
                                It may generate console errors if a user has over 1000 notifications.
                                -->
                                <v-divider
                                    v-if="index + 1 < notifications.length"
                                    :key="index + 1000"
                                >
                                </v-divider>
                            </template>
                        </v-col>
                    </v-row>
                </v-list>
                <v-bottom-navigation horizontal absolute height="36">
                    <v-btn
                        @click="deleteAllNotifications"
                        color="pink--text"
                        class="flex-grow-1 flex-shrink-1"
                    >
                        <span>Delete All</span>
                        <!-- <v-icon class="mr-1">mdi-trash-can-outline</v-icon> -->
                    </v-btn>
                    <v-btn
                        @click="markAllNotificationsRead"
                        color="primary--text"
                        class="flex-grow-1 flex-shrink-1"
                    >
                        <span>Mark All as Read</span>
                        <!-- <v-icon class="mr-1">mdi-check</v-icon> -->
                    </v-btn>
                </v-bottom-navigation>
            </v-menu>

            <!-- Profile -->
            <v-menu
                v-if="$vuetify.breakpoint.lgAndUp"
                offset-y
                z-index="9"
            >
                <template v-slot:activator="{ on }">
                    <v-btn text class="align-self-center noBtnCase" v-on="on">
                        <template v-if="userSettings.show_name"> {{ fullname }} </template>
                        <v-avatar left color="primary lighten-3" class="ml-2">
                            <v-img
                                alt="User avatar image"
                                :src="avatarLink"
                                v-if="avatarLink && userSettings.show_avatar"
                            ></v-img>
                            <v-icon v-else>mdi-account-outline</v-icon>
                        </v-avatar>
                        <v-icon right>mdi-menu-down</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-group
                        class="blue lighten-5"
                        no-action
                        @click.stop="() => {}"
                    >
                        <template #activator>
                            <v-list-item-avatar>
                                <v-icon>
                                    mdi-account-outline
                                </v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title>
                                    Support Officer
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    class="grey--text text--darken-1"
                                >
                                    {{ accountOfficer.firstname }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>

                        <v-list-item
                            :href="`mailto:${accountOfficer.email}`"
                            class="pl-4 grey--text text--darken-1"
                            dense
                        >
                            <v-list-item-avatar>
                                <v-icon>
                                    mdi-email-outline
                                </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ accountOfficer.email }}
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action class="ma-0">
                                <v-btn icon>
                                    <v-icon color="grey">
                                        mdi-open-in-new
                                    </v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>

                        <v-list-item
                            :href="`https://wa.me/${accountOfficer.phone && accountOfficer.phone.substring(1)}`"
                            target="_blank"
                            class="pl-4 grey--text text--darken-1"
                            dense
                        >
                            <v-list-item-avatar>
                                <v-icon>
                                    mdi-whatsapp
                                </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ accountOfficer.phone }}
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action class="ma-0">
                                <v-btn icon>
                                    <v-icon color="grey">
                                        mdi-open-in-new
                                    </v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>

                        <v-list-item
                            href="https://twitter.com/messages/compose?text=Hello&recipient_id=1177321542574845952"
                            target="_blank"
                            class="pl-4 grey--text text--darken-1"
                            dense
                        >
                            <v-list-item-avatar>
                                <v-icon>
                                    mdi-twitter
                                </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    @kaoshinetwork
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action class="ma-0">
                                <v-btn icon>
                                    <v-icon color="grey">
                                        mdi-open-in-new
                                    </v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list-group>

                    <template
                        v-for="(item, key) in dropdownItems"
                    >
                        <v-list-item
                            :key="key"
                            :to="item.route"
                            :exact="item.exact"
                            :class="item.class"
                        >
                            <v-list-item-icon>
                                <v-icon>
                                    mdi-{{ item.icon }}
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title :class="item.class">
                                {{ item.text }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-divider :key="`divider-${key}`" />
                    </template>

                    <v-list-item
                        v-if="!loading"
                        class="error--text"
                        @click.prevent="logout"
                    >
                        <v-list-item-icon>
                            <v-icon color="error">
                                mdi-logout
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Logout</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar-items>

        <v-toolbar-items
            v-else
            class="align-center"
        >
            <div>
                <v-btn
                    color="white"
                    class="primary--text font-weight-bold"
                    :to="{
                        name: 'login',
                    }"
                >
                    Login
                </v-btn>
            </div>
        </v-toolbar-items>

        <v-app-bar-nav-icon
            class="hidden-lg-and-up"
            @click.stop="toggleSidebar"
        />

        <ActionNotificationModal
            v-for="(notification, key) in unreadActionNotifications"
            :key="key"
            :notification="notification"
        />
    </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import MySocket from '../../services/MySocket';
import ServerUtils from '../../services/ServerUtils';
import FormFillerService from '../../services/FormFillerService';
import emailApiFetcher from '../../mixins/email-service-api.mixin';
import healthModal from './components/health-modal.vue';
import invoiceModal from '../invoice/invoice-modal.vue';
import shoppingModal from './components/shopping-modal.vue';
import walletModel from './components/wallet-model.vue';
import autoloanModal from './components/autoloan-modal.vue';
import ActionNotificationModal from './components/action-notification-modal.vue';

const modals = [
    'showHealthModal',
    'showInvoiceModal',
    'showShoppingModal',
    'showAutoLoanModal',
    'showWalletModal',
];

export default {
    components: {
        healthModal,
        invoiceModal,
        shoppingModal,
        walletModel,
        autoloanModal,
        ActionNotificationModal,
    },
    methods: getMethods(),
    computed: getComputed(),
    mixins: [clickaway, emailApiFetcher],
    mounted: mounted,
    data: data,
    watch: getWatchers(),
    beforeDestroy: beforeDestroy
};

function getComputed() {
    return {
        ...mapGetters([
            'isUserAuthenticated',
        ]),
        ...mapGetters('navigation', [
            'homepageRoute',
            'navItems',
            'menuNavItems',
        ]),
        ...modals.reduce((obj, item) => {
            return {
                ...obj,
                [item]: {
                     get() {
                        return this.$store.state.navigation[item];
                    },
                    set(value) {
                        this.$store.commit('navigation/SET_MODAL_STATE', {
                            type: item,
                            value,
                        });
                    },
                },
            };
        }, {}),
        pageHeaderTitle,
        avatarLink,
        newNotifications,
        newNotificationsCount,
        transfersLink,
        fullname,
        userSettings,
        unreadMessagesCount,
        userEmail,
        userKaoshiEmail,
        dropdownItems,
        navbarItems,
        accountOfficer,
        unreadActionNotifications,
    };

    function dropdownItems() {
        return this.menuNavItems.slice(3);
    }

    function navbarItems() {
        return this.menuNavItems.slice(0, 3);
    }

    function newNotifications() {
        return this.notifications.filter((item) => {
            return !item.read_at;
        });
    }

    function newNotificationsCount() {
        return this.newNotifications.length;
    }

    function pageHeaderTitle() {
        return this.$store.state.pageHeaderTitle;
    }

    function avatarLink() {
        return this.$store.state.user.avatar;
    }

    function transfersLink() {
        return '/transfers';
    }

    function fullname() {
        return `${this.$store.state.user.firstname} ${this.$store.state.user.lastname}`;
    }

    function userSettings() {
        if (_.isEmpty(this.$store.state.userSettings)) {
            return {
                show_name: true,
                show_avatar: true,
            };
        }

        return this.$store.state.userSettings;
    }

    function unreadMessagesCount() {
        return this.$store.state.unreadMessagesCount;
    }

    function userEmail() {
        return this.$store.state.user.email;
    }

    function userKaoshiEmail() {
        return this.$store.state.user.kaoshi_email;
    }

        function accountOfficer() {
            return this.$_user.accountOfficer || {};
        }

    function unreadActionNotifications() {
        return this.notifications.filter((notification) => !!notification.actions && !notification.read_at);
    }
}

function getWatchers() {
    return {
        /**
         * Start pulse and make sound when a notification is changed.
         *
         * @param value
         */
        notifications: function(value) {
            let currentNotificationCount = this.notifications.length;
            this.notifMenuCloseOnClick = false;

            if (currentNotificationCount > 0) {
                this.enableNotificationButton = true;
            } else {
                this.enableNotificationButton = false;
            }

            if (
                currentNotificationCount > this.previousNotificationCount &&
                !this.firstLoad
            ) {
                let soundFile = '/sounds/notification.mp3';
                let theSound = new Audio(soundFile);
                theSound.play();
                this.enableNotificationButton = true;

                let that = this;
            } else {
                this.firstLoad = false;
            }

            this.previousNotificationCount = this.notifications.length;
        },
        showNotifications() {
            this.$emit('update:overlay', this.showNotifications);
        },
    };
}

function beforeDestroy() {
    const vm = this;
    removeSocketListener();

    function removeSocketListener() {
        MySocket.remove('notification');

        MySocket.remove('acceptedMatch');
        MySocket.remove('matchCancelled');
        MySocket.remove('matcherPaid');
        MySocket.remove('matcherPaymentCompleted');

        MySocket.remove('orderRequested');
        MySocket.remove('paymentRequestDeclined');
        MySocket.remove('paymentRequestAccepted');
    }
}

function data() {
    return {
        rotateDropdown: false,
        loading: false,
        notifications: [],
        previousNotificationCount: 0,
        notificationAnimationState: 'paused',
        timeouts: [],
        firstLoad: true,
        notifMenuCloseOnClick: false,
        enableNotificationButton: false,
        headerTabsMaxWidth: '100%',
        componentKey: 0,
        showNotifications: false,
        showComingSoon: false,
    };
}

function getMethods() {
    return {
        ...mapActions('auth', {
            logoutUser: 'logout',
        }),
        ...mapActions('sidebar', [
            'toggleSidebar',
        ]),
        logout,
        markAllNotificationsRead: markAllNotificationsRead,
        markNotificationRead: markNotificationRead,
        deleteAllNotifications: deleteAllNotifications,
        deleteNotification: deleteNotification,
        getActiveMatchesCount() {
            if (this.isUserAuthenticated && this.$store.state.user.can_accept_offers) {
                Vue.backendApi().pendingMatches().getCount('active').then((response) => {
                    const { count } = response.data;
                    this.$store.commit('storeActiveMatchesCount', count || 0);
                });
            } else {
                this.$store.commit('storeActiveMatchesCount', 0);
            }
        },
        getActiveRequestsCount() {
            if (this.isUserAuthenticated && this.$store.state.user.can_post_offers) {
                Vue.backendApi().paymentRequest().getCount('active').then((response) => {
                    const { count } = response.data;
                    this.$store.commit('storeActiveRequestsCount', count || 0);
                });
            } else {
                this.$store.commit('storeActiveRequestsCount', 0);
            }
        },
        isProduction() {
            return ServerUtils.isProduction();
        }
    };

        async function logout() {
            try {
                if (document.pictureInPictureElement) {
                    document.exitPictureInPicture();
                }

                this.loading = true;
                await this.logoutUser();
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'An error occurred.',
                    text: error,
                });
            } finally {
                this.loading = false;
            }
        }

    function markAllNotificationsRead() {
        const vm = this;
        var notificationIds = this.newNotifications.map(
            (notification) => notification.id
        );

        if (notificationIds.length < 1) {
            return;
        }

        const payload = {
            notification_ids: notificationIds
        };

        Vue.backendApi()
            .notifications()
            .markAsRead(payload)
            .then(success, error);

        function success(response) {
            vm.notifications = vm.notifications.map((notification) => {
                if (notificationIds.indexOf(notification.id) >= 0) {
                    Vue.set(notification, 'read_at', new Date());
                }
                return notification;
            });
        }

        function error(error) {
            vm.$swal({
                type: 'error',
                title: 'Error marking notifications as read',
                text: error
            });
        }
    }

    /*
     * @param     {object} notification   selected notification
     * @returns   {object} notification   notification with updated read_at date
     */
    function markNotificationRead(notification) {
        const vm = this;

        if (!notification.id) {
            return;
        }

        const payload = {
            notification_ids: [notification.id]
        };

        Vue.backendApi()
            .notifications()
            .markAsRead(payload)
            .then(success, error);

        function success(response) {
            Vue.set(notification, 'read_at', new Date());
            return notification;
        }

        function error(error) {
            vm.$swal({
                type: 'error',
                title: 'Error marking notification as read',
                text: error
            });
        }
    }

    function deleteAllNotifications() {
        const vm = this;

        if (vm.notifications.length < 1) {
            return;
        }

        vm.notifMenuCloseOnClick = true;

        vm.notifications.forEach((notification) => {
            Vue.backendApi()
                .notifications()
                .destroy(notification.id)
                .then(success, error);
        });

        function success(response) {
            vm.notifications = [];
        }

        function error(error) {
            vm.$swal({
                type: 'error',
                title: 'Error deleting all notifications',
                text: error
            });
        }
    }

    function deleteNotification(notification) {
        const vm = this;

        if (!notification.id) {
            return;
        }

        Vue.backendApi()
            .notifications()
            .destroy(notification.id)
            .then(success, error);

        function success(response) {
            vm.notifications = vm.notifications.filter(
                (_notification) => _notification.id !== notification.id
            );
        }

        function error(error) {
            vm.$swal({
                type: 'error',
                title: 'Error marking notifications as read',
                text: error
            });
        }

        let isLastNotificaion = vm.notifications.length === 1;
        if (isLastNotificaion) {
            vm.notifMenuCloseOnClick = true;
        }
    }
}

function mounted() {
    // This is a temporal fix to prevent the header overflowing on large screen
    // We need to find later a better solution, maybe review the v-app-bar content
    this.$nextTick(() => {
        if (this.$refs.profileInfo) {
            const profileInfoWidth = this.$refs.profileInfo.offsetWidth  + 120;
            this.headerTabsMaxWidth = 'calc(100% - ' + profileInfoWidth + 'px)';
        }
    })

    const vm = this;
    addSocketListeners();
    getNotifications();
    //Load user settings if authenticated
    loadUserSettings();
    vm.fetchUnreadMessagesCount();

    this.getActiveMatchesCount();
    this.getActiveRequestsCount();

    function addSocketListeners() {
        MySocket.on('notification', (notification) => {
            vm.notifications.unshift(notification);
        });

        MySocket.on('emailConfirmationLinkReceived', (notification) => {
            FormFillerService.sendEmailConfirmationLink(notification);
        });

        MySocket.on('passwordResetLinkReceived', (notification) => {
            FormFillerService.sendPasswordResetLink(notification);
        });

        MySocket.on('problemReportReplied', (notification) => {
            FormFillerService.sendProblemReportReplied(notification);
        });

        MySocket.on('userUpdated', (notification) => {
            vm.$store.commit('storeUser', {
              ...vm.$store.state.user,
              ...notification,
            });
        });

        MySocket.on('acceptedMatch', vm.getActiveMatchesCount);
        MySocket.on('matchCancelled', vm.getActiveMatchesCount);
        MySocket.on('matcherPaid', vm.getActiveMatchesCount);
        MySocket.on('matcherPaymentCompleted', vm.getActiveMatchesCount);

        MySocket.on('orderRequested', (paymentRequest) => {
            if (paymentRequest.user_id === vm.$store.state.user.id) {
                vm.getActiveRequestsCount();
            }
        });
        MySocket.on('paymentRequestDeclined', (paymentRequest) => {
            if (paymentRequest.user_id === vm.$store.state.user.id) {
                vm.getActiveRequestsCount();
            }
        });
        MySocket.on('paymentRequestAccepted', (paymentRequest) => {
            if (paymentRequest.user_id === vm.$store.state.user.id) {
                vm.getActiveRequestsCount();
            }
        });
    }

    function getNotifications() {
        if (vm.isUserAuthenticated) {
            Vue.backendApi()
                .user(vm.$_user.id)
                .getNotifications()
                .then(success, error);
        }

        function success(response) {

            if (response) {
                const sortedNotifications = response.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                Vue.set(vm, 'notifications', sortedNotifications);
            }

        }

        function error(error) {
            vm.$swal({
                type: 'error',
                title: 'Error loading notifications',
                text: error
            });
        }
    }

    function loadUserSettings() {
        Vue.backendApi()
            .user(vm.$store.state.user.id)
            .getUserSettings()
            .then(({ data }) => {
                vm.$store.commit('loadUserSettings', data);
            });
    }
}
</script>

<style scoped>
.navbar-item {
    line-height: 1.3em;
    max-width: 100px;
}

.notification >>> a {
  text-decoration: underline;
}

.v-btn--fab.xx-small {
    height: 26px;
    width: 26px;
}

#headerTabs .v-tab,
.noBtnCase {
    text-transform: unset;
    font-weight: 600;
}

.notificationsList {
    overflow: auto;
}

.theme--light.v-bottom-navigation .v-btn:not(.v-btn--active) {
    color: #3f51b5 !important;
}

.v-menu__content .notificationsList .v-list-item.read .v-list-item__content {
    opacity: 0.3;
}
.coming-soon:after {
    /* content: "COMING SOON!"; */
    content: "";
    font-size: .6em;
    text-transform: uppercase;
    color: #ffeb94;
    position: absolute;
    left: 0;
    right: 0;
    top: 44px;
    z-index: 10;
    opacity: 1;
}

@media screen and (min-width: 960px) {
    .v-toolbar__content .v-btn.v-btn--icon.v-size--default, .v-toolbar__extension .v-btn.v-btn--icon.v-size--default {
        width: 64px;
    }
}
</style>
